import { login } from "../api/auth";
import { WhitelabelConfig } from "../config/whitelabel";

export function montarLogin(container: HTMLElement, config: WhitelabelConfig, aoLogar: () => void): void {
  container.innerHTML = `
    <div class="login-shell">
      <div class="login-card">
        <img src="${config.brand.logoUrl}" alt="${config.brand.name}" />
        <div class="erro" id="login-erro"></div>
        <label>E-mail <input id="login-email" type="email" autocomplete="username" /></label>
        <label>Senha <input id="login-senha" type="password" autocomplete="current-password" /></label>
        <button class="botao" id="login-botao">Entrar</button>
      </div>
    </div>
  `;

  const botao = container.querySelector<HTMLButtonElement>("#login-botao")!;
  const emailInput = container.querySelector<HTMLInputElement>("#login-email")!;
  const senhaInput = container.querySelector<HTMLInputElement>("#login-senha")!;
  const erroEl = container.querySelector<HTMLElement>("#login-erro")!;

  async function tentarLogin() {
    erroEl.textContent = "";
    try {
      await login(emailInput.value.trim(), senhaInput.value);
      aoLogar();
    } catch {
      erroEl.textContent = "e-mail ou senha inválidos";
    }
  }

  botao.addEventListener("click", tentarLogin);
  senhaInput.addEventListener("keydown", (ev) => {
    if (ev.key === "Enter") tentarLogin();
  });
}
